<template>
  <b-field
    :label="label"
    :type="(hasError() ? 'is-danger': '')"
    :message="errorMessage()"
  >
    <v-autocomplete-fetch
      :value="value"
      :route="route"
      :field="field"
      :icon="icon"
      :placeholder="placeholder"
      :maxlength="maxlength"
      :open-on-focus="openOnFocus"
      :keep-first="keepFirst"
      :disabled="disabled"
      :parameters="parameters"
      @typing="$emit('typing', $event)"
      @input="onInput"
    >
      <template
        slot="selection"
        slot-scope="scope"
      >
        <slot
          v-bind="scope"
          name="selection"
        />
      </template>
      <template
        slot="default"
        slot-scope="scope"
      >
        <slot
          v-bind="scope"
          name="default"
        />
      </template>
    </v-autocomplete-fetch>
  </b-field>
</template>

<script>
import InputBase from "./InputBase";
import AutocompleteFetchVue from "../components/AutocompleteFetch.vue";

export default {
  components: {
    "v-autocomplete-fetch": AutocompleteFetchVue
  },
  extends: InputBase,
  props: {
    value: {
      default: null,
      validator (value) {
        return _.isString(value) || _.isObject(value);
      }
    },
    route: {
      required: true,
      type: String
    },
    field: {
      default: undefined,
      type: String
    },
    icon: {
      default: "magnify",
      type: String
    },
    maxlength: {
      type: Number,
      default: undefined
    },
    openOnFocus: {
      type: Boolean,
      default: false
    },
    keepFirst: {
      type: Boolean,
      default: true
    },
    disabled: {
      default: false,
      type: Boolean
    },
    parameters: {
      default () {
        return {};
      },
      type: Object
    },
  },
  data () {
    return {
      query: "",
      page: 0,
      stopScroll: false,
      data: [],
      isFetching: false
    };
  },
  methods: {
    onInput (event) {
      this.inputListener(event);
    }
  }
};
</script>
